import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { request } from "../request";
import { useState } from "react";
import useRefresh from "../utils/useRefresh";
export default function Reset({ open, handleClose }) {
  const storeId = window.localStorage.getItem("storeId");
  const handleRefresh = useRefresh();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [password, setPassword] = useState("");
  const handleResetStore = async () => {
    if (!password) {
      alert("Provide admin password");
    } else {
      try {
        const res = await request.delete(
          `/store/reset?id=${storeId}&adminPass=${password}`,
        );
        alert(res.data);
        handleRefresh(storeId);
        handleClose();
      } catch (err) {
        alert(err.response.data || "Error occurred. Try again");
      }
    }
  };
  return (
    <div style={{ zIndex: 999999999 }}>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Reset Store</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This operation will reset your store data. Data will be permanently
            deleted unless you contact admin or have already backed up your
            data. Are you sure you want to proceed?
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="admin password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(e) => setPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button className="btn" onClick={handleClose}>
            cancel
          </Button>
          <Button onClick={handleResetStore}>Reset Shop</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
